const INVOICES_KEY = "wl_bs_invoices_extras";
const GENERATED_STATEMENTS_KEY = "wl_bs_open_statements_generated";
const STATEMENT_OVERRIDES_KEY = "wl_bs_statement_overrides";
const SUBUSER_INVOICES_KEY = "wl_bs_subuser_invoices_extras";
const SUBUSER_INVOICE_OVERRIDES_KEY = "wl_bs_subuser_invoice_overrides";
const TENANT_INVOICE_CONFIG_KEY = "wl_bs_tenant_invoice_config";
const TAX_RATE_EXTRAS_KEY = "wl_bs_tax_rate_extras";
const TAX_RATE_DELETED_KEY = "wl_bs_tax_rate_deleted";

function readJson(key, fallback) {
  if (typeof sessionStorage === "undefined") {
    return fallback;
  }
  try {
    const raw = sessionStorage.getItem(key);
    if (raw == null) {
      return fallback;
    }
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // no-op
  }
}

export function clearDemoInvoiceSessionStorage() {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(INVOICES_KEY);
  sessionStorage.removeItem(GENERATED_STATEMENTS_KEY);
  sessionStorage.removeItem(STATEMENT_OVERRIDES_KEY);
  sessionStorage.removeItem(SUBUSER_INVOICES_KEY);
  sessionStorage.removeItem(SUBUSER_INVOICE_OVERRIDES_KEY);
  sessionStorage.removeItem(TENANT_INVOICE_CONFIG_KEY);
  sessionStorage.removeItem(TAX_RATE_EXTRAS_KEY);
  sessionStorage.removeItem(TAX_RATE_DELETED_KEY);
}

export function getDemoInvoiceRows() {
  const rows = readJson(INVOICES_KEY, []);
  return Array.isArray(rows) ? rows : [];
}

export function upsertDemoInvoice(row) {
  if (!row || row.id == null) {
    return;
  }
  const sid = String(row.id);
  const rows = getDemoInvoiceRows();
  const idx = rows.findIndex(r => String(r.id) === sid);
  if (idx >= 0) {
    rows[idx] = { ...rows[idx], ...row };
  } else {
    rows.unshift(row);
  }
  writeJson(INVOICES_KEY, rows);
}

export function getGeneratedOpenStatements() {
  const rows = readJson(GENERATED_STATEMENTS_KEY, []);
  return Array.isArray(rows) ? rows : [];
}

export function setGeneratedOpenStatements(rows) {
  writeJson(GENERATED_STATEMENTS_KEY, Array.isArray(rows) ? rows : []);
}

export function getStatementOverridesMap() {
  const map = readJson(STATEMENT_OVERRIDES_KEY, {});
  return map && typeof map === "object" && !Array.isArray(map) ? map : {};
}

export function markStatementsInvoiced(statementIds) {
  const ids = (statementIds || []).map(String).filter(Boolean);
  if (!ids.length) {
    return;
  }
  const overrides = getStatementOverridesMap();
  ids.forEach(id => {
    overrides[id] = { ...(overrides[id] || {}), invoice_generated: true };
  });
  writeJson(STATEMENT_OVERRIDES_KEY, overrides);
}

export function upsertStatementOverride(id, patch) {
  if (id == null || !patch || typeof patch !== "object") {
    return;
  }
  const sid = String(id);
  const overrides = getStatementOverridesMap();
  overrides[sid] = { ...(overrides[sid] || {}), ...patch };
  writeJson(STATEMENT_OVERRIDES_KEY, overrides);
}

export function getDemoSubuserInvoiceRows() {
  const rows = readJson(SUBUSER_INVOICES_KEY, []);
  return Array.isArray(rows) ? rows : [];
}

export function upsertDemoSubuserInvoice(row) {
  if (!row || row.id == null) {
    return;
  }
  const sid = String(row.id);
  const rows = getDemoSubuserInvoiceRows();
  const idx = rows.findIndex(r => String(r.id) === sid);
  if (idx >= 0) {
    rows[idx] = { ...rows[idx], ...row };
  } else {
    rows.unshift(row);
  }
  writeJson(SUBUSER_INVOICES_KEY, rows);
}

export function getSubuserInvoiceOverridesMap() {
  const map = readJson(SUBUSER_INVOICE_OVERRIDES_KEY, {});
  return map && typeof map === "object" && !Array.isArray(map) ? map : {};
}

export function upsertSubuserInvoiceOverride(id, patch) {
  if (id == null || !patch || typeof patch !== "object") {
    return;
  }
  const sid = String(id);
  const overrides = getSubuserInvoiceOverridesMap();
  overrides[sid] = { ...(overrides[sid] || {}), ...patch };
  writeJson(SUBUSER_INVOICE_OVERRIDES_KEY, overrides);
}

export function getTenantInvoiceConfigOverride() {
  const data = readJson(TENANT_INVOICE_CONFIG_KEY, null);
  return data && typeof data === "object" && !Array.isArray(data) ? data : null;
}

export function setTenantInvoiceConfigOverride(config) {
  writeJson(TENANT_INVOICE_CONFIG_KEY, config && typeof config === "object" ? config : {});
}

export function getTaxRateExtras() {
  const rows = readJson(TAX_RATE_EXTRAS_KEY, []);
  return Array.isArray(rows) ? rows : [];
}

export function upsertTaxRateExtra(row) {
  if (!row || row.id == null) {
    return;
  }
  const sid = String(row.id);
  const rows = getTaxRateExtras();
  const idx = rows.findIndex(r => String(r.id) === sid);
  if (idx >= 0) {
    rows[idx] = { ...rows[idx], ...row };
  } else {
    rows.unshift(row);
  }
  writeJson(TAX_RATE_EXTRAS_KEY, rows);
}

export function getTaxRateDeletedIds() {
  const rows = readJson(TAX_RATE_DELETED_KEY, []);
  return Array.isArray(rows) ? rows.map(String) : [];
}

export function markTaxRateDeleted(id) {
  if (id == null) {
    return;
  }
  const sid = String(id);
  const deleted = getTaxRateDeletedIds();
  if (!deleted.includes(sid)) {
    deleted.push(sid);
    writeJson(TAX_RATE_DELETED_KEY, deleted);
  }
}
